export default [
	'Act',
	'Est',
	'Loan',
];